import { memo, useEffect } from "react";
import { CallBackGivenForDismiss } from "../utils/AppUtils";

function DismissComp() {
  useEffect(() => {
    CallBackGivenForDismiss();
    //Scripts may close only the windows that were opened by them.
    return window.close();
  }, []);

  return (
    <>
      <div
        className="attendee-host-disconnect"
        style={{ display: "flex" }}
      ></div>
    </>
  );
}
export default memo(DismissComp);
